import React from 'react';
import { PropTypes } from 'prop-types';
import { compose, pure } from 'recompose';
import Select from 'components/CustomSelect';

import { DropdownOption } from 'refactored/ui/form';

const enhance = compose(pure);

const RelativeDatePicker = ({
  t,
  label,
  value,
  handleChange,
  className,
  options,
  subLabel,
}) => (
  <div className={className}>
    <Select
      value={options.find((option) => String(option.value) === String(value))}
      label={label}
      subLabel={subLabel}
      placeholder={label}
      options={options}
      isSearchable={false}
      onChange={handleChange}
      components={{ Option: DropdownOption }}
      dataE2E="select_load_type"
      t={t}
    />
  </div>
);

RelativeDatePicker.propTypes = {
  value: PropTypes.instanceOf(Date),
  className: PropTypes.string,
  t: PropTypes.func.isRequired,
  handleChange: PropTypes.func,
  label: PropTypes.string.isRequired,
  subLabel: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.object),
};

RelativeDatePicker.defaultProps = {
  value: null,
  className: '',
  handleChange: () => {},
  options: [],
};

export default enhance(RelativeDatePicker);
